const config = require('../config');
const isServer = () => typeof window === 'undefined';

/**
 * @param {string} url
 * @returns {string}
 */
const removeDoubleSlash = (url) => {
    return url ? url.replace('//', '/') : '';
};

/**
 * @param {import('@tidal/tracking').EventDataParams & import('@tidal/tracking').OptionalParams} eventData
 * @returns { { platform: string|undefined, deviceType: string|undefined } }
 */
const getPlatformAndDeviceType = (eventData) => {
    const platform = eventData.appMode && eventData.appMode.type
        ? eventData.appMode.type.toLowerCase() : '';

    if (['web', 'desktop'].includes(platform)) {
        return { platform, deviceType: platform };
    } else if (['android', 'ios'].includes(platform)) {
        return { platform, deviceType: 'mobile' };
    } else {
        return {
            platform: eventData.platform,
            deviceType: eventData.deviceType,
        };
    }
};

/** @param {import('@tidal/tracking').EventDataParams & import('@tidal/tracking').OptionalParams} eventData */
const getClientData = (eventData) => {
    return Object.assign(
        {
            token: config.TIDAL_TOKEN,
            version: '',
        }, getPlatformAndDeviceType(eventData));
};

/** @param {import('@tidal/tracking').EventDataParams & import('@tidal/tracking').OptionalParams} eventData */
const getBasePayloadData = (eventData) => {
    return {
        pageId: eventData.path ? removeDoubleSlash(eventData.path) : window.location.pathname,
        hostname: window.location.hostname,
        campaignId: eventData.campaignId,
        webSessionId: eventData.trackingUuid,
        userId: eventData.userId,
        countryCode: eventData.geo,
        subscriptionType: eventData.type,
        planType: eventData.plan,
        paymentType: eventData.paymentType,
    };
};

module.exports = {
    getBasePayloadData,
    getClientData,
    getPlatformAndDeviceType,
    isServer,
};
